import store2 from 'store2'
import { getAppName, getNativeInfo } from '../common/jsbridge'
import { getLanguage } from './browser'

const CMSHosts = ['https://cloud-cms-qa.eufylife.com']
export const listenCMSMessgafeData = callback => {
  if (typeof window === 'undefined') return
  window.addEventListener('message', ({ data, origin }) => {
    if (CMSHosts.includes(origin)) {
      console.log('message from CMS =', data)
      callback(data)
    }
  })
}

/**
 *
 * @param v1 4.2.5_1321 or 4.2.5_1321
 * @param v2 4.2.5_1321 or 4.2.5_1321
 * @return 1: v1 > v2; 0: v1 == v2; -1: v1 < v2
 */
export const compareVersion = (v1: string, v2: string) => {
  const _v1 = v1
    .replace(/v/g, '')
    .replace(/[a-zA-Z]+_/g, '')
    .split('_') // [4.2.5, 1321] or [4.2.5, 1321]
  const _v2 = v2
    .replace(/v/g, '')
    .replace(/[a-zA-Z]+_/g, '')
    .split('_') // [4.2.5, 1321] or [4.2.5, 1321]
  const _len1 = _v1.length
  const _len2 = _v2.length

  const __v1 = _v1[0].split('.')
  const __v2 = _v2[0].split('.')
  const __n1 = parseInt(_v1[_len1 - 1])
  const __n2 = parseInt(_v2[_len2 - 1])
  const __len1 = __v1.length
  const __len2 = __v2.length

  const minlen = Math.min(__len1, __len2)
  for (let i = 0; i < minlen; i++) {
    const a = parseInt(__v1[i])
    const b = parseInt(__v2[i])
    if (a > b) {
      return 1
    } else if (a < b) {
      return -1
    }
  }
  if (__n1 > __n2) {
    return 1
  } else if (__n1 < __n2) {
    return -1
  }
  return 0
}

/*
 * 存local数据
 */
export function setLocalStorage(
  key: string,
  data: unknown,
  overwrite?: boolean
): unknown {
  // overwrite如果是number代表过期的秒数
  return store2.set(key, data, overwrite)
}

/**
 * 取local数据
 */
export function getLocalStorage<T extends unknown>(
  key: string,
  alt?: unknown
): T {
  return store2.get(key, alt)
}

export function hasLocalSrorage(key: string): boolean {
  return store2.has(key)
}

/**
 * 存session数据
 */
export function setSessionStorage(
  key: string,
  data: unknown,
  overwrite?: boolean
): unknown {
  return store2.session.set(key, data, overwrite)
}

/**
 * 取 session 数据
 */
export function getSessionStorage<T extends unknown>(
  key: string,
  alt?: unknown
): T {
  return store2.session.get(key, alt)
}

export function hasSessionSrorage(key: string): boolean {
  return store2.session.has(key)
}

export function isAr() {
  return Boolean(getLanguage().match(/^ar/)) || false
}

export function getTextDirection() {
  if (isAr()) {
    return 'rtl'
  }
  return 'ltr'
}

export function isQa() {
  const env = process.env.GATSBY_DEPLOY_ENV || 'qa'
  return env === 'qa'
}

export async function isEu() {
  const { domain } = await getNativeInfo()
  return domain.includes('-eu') && !domain.includes('-qa')
}

export async function isEuQa() {
  const { domain } = await getNativeInfo()
  return domain.includes('-eu-qa')
}
export async function isIeQa() {
  const { domain } = await getNativeInfo()
  return domain.includes('-ie-qa')
}

export async function isV2ApiAvail() {
  const appname = (await getAppName()) || ''
  const info = await getNativeInfo()
  const version = info?.appVersion?.match(/[\d\.]/g)?.join('') || ''
  console.log('appname', appname, version)
  return appname.toLowerCase().includes('security') && version >= '4.5.1'
}
